import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import AutoPayFalseTabs from './AutoPayFalse';
import PresentmentFilterForm from './PresentmentFilterForm';
import AutoPayTrueFilterList from './AutoPayTrue/FilteredList';
import { BulkUploadFile } from './BulkUpload';
import NachSection from './nach/NachSection';
import NoMappingData from './noMapping/NoMappingData';
import { usePresentmentFilterContext } from '../context/PresenmentFilterProvider';

function PresentmentTabs() {
  // const [currentKey, setCurrentKey] = useState(1);
  const { setCurrentActiveTabKey, currentActiveTabKey } = usePresentmentFilterContext();
  // const [isPending,startTransition]=useTransition();
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Upload File',
      children: <BulkUploadFile />,
    },
    {
      key: '2',
      label: 'NACH',
      children: <NachSection />,
    },
    {
      key: '3',
      label: 'Auto Pay True',
      children: (
        <div style={{ marginLeft: '', marginTop: '-9px' }}>
          <AutoPayTrueFilterList />
        </div>
      ),
    },
    {
      key: '4',
      label: 'Auto Pay False',
      children: <AutoPayFalseTabs />,
    },
    {
      key: '5',
      label: 'No LoanType Mapping',
      children: <NoMappingData />,
    },
  ];

  const handleTabChange = (key: any) => {
    setCurrentActiveTabKey(key);
  };

  return (
    <div className="row">
      <div className="col-xs-12 col-sm-12 col-md-12">
        {currentActiveTabKey != 1 && <PresentmentFilterForm />}
        <div>
          <Tabs
            defaultActiveKey="1"
            centered
            type="card"
            items={items}
            onChange={handleTabChange}
          />
        </div>
      </div>
    </div>
  );
}

export default PresentmentTabs;
